import { render, staticRenderFns } from "./MixedPage.vue?vue&type=template&id=5571bac2&"
import script from "./MixedPage.vue?vue&type=script&lang=js&"
export * from "./MixedPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports